import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable()
export class AccountHttpInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event?.url) {
            const pathname = new URL(event?.url).pathname;
            if (pathname.includes('payment-cards')) {
              // Check for the presence of the header you are interested in
              const etag = event.headers.get('etag');
              if (etag) {
                // Store the header value in local storage
                localStorage.setItem('WALLET-ETAG', etag);
              }
            }
          }
        }
      }),
    );
  }
}
